<template>
  <el-container
    class="container"
    style="align-items: center; justify-content: center"
  >
    <el-col
      :xs="24"
      :sm="20"
      :md="18"
      :lg="16"
      :xl="14"
      style="align-items: center; justify-content: space-around"
    >
      <el-row
        class="hide-on-print" type="flex"
        justify="end"
      >
        <el-button @click="$goBack()">
          Volver
        </el-button>
      </el-row>
      <p class="title">
        Detalle del predio
      </p>
      <el-row
        :gutter="20" type="flex"
        justify="space-between"
      >
        <el-col :span="11">
          <p class="badge-title">
            DATOS DEL CIUDADANO
          </p>
          <p class="subtitle">
            <b>Nombre:</b>
            {{ user.nombrecompletopropietario }}
          </p>
          <p class="subtitle">
            <b>Dom. a notificar:</b>
            {{ user.domicilio_notificacion }}
          </p>
        </el-col>
        <el-col :span="11">
          <img
            src="../assets/logo-tesoreria.png"
            class="logo"
          >
        </el-col>
      </el-row>
      <el-row
        :gutter="20" type="flex"
        justify="space-between"
      >
        <el-col :span="11">
          <p class="badge-title">
            DATOS DEL PREDIO
          </p>
          <p class="subtitle">
            <b>Recaudadora:</b>
            {{ user.cuentadepredial.substring(0, 4) }}
          </p>
          <p class="subtitle">
            <b>Cuenta predial:</b>
            {{ user.cuentadepredial.substring(4, undefined) }}
          </p>
          <p class="subtitle">
            <b>Domicilio del predio:</b>
            {{ user.ubicacion }}
          </p>
          <br>
          <br>
          <p class="subtitle">
            <b>Sup. Terreno:</b>
            {{ $numberFormater(user.superfice_terreno, true) }}
          </p>
          <p class="subtitle">
            <b>Sup. Construcción:</b>
            {{ $numberFormater(user.superficie_construida, true) }}
          </p>
        </el-col>
        <el-col :span="11">
          <p class="subtitle" style="margin-top: 30px">
            <b>Clave Catastral:</b>
            {{ user.clave_catastral }}
          </p>
          <p class="subtitle">
            <b>Val. Terreno:</b>
            {{ $currencyFormater(user.valor_del_terreno) }}
          </p>
          <br>
          <p class="subtitle">
            <b>Val. Construcción:</b>
            {{ $currencyFormater(user.valor_de_la_construccion) }}
          </p>
          <br>
          <p class="subtitle">
            <b>Val. Fiscal:</b>
            {{ $currencyFormater(user.valor_de_fiscal) }}
          </p>
          <p class="subtitle">
            <b>Estatus de predio:</b>
            {{ user.estatus_del_predio }}
          </p>
        </el-col>
      </el-row>
      <el-row
        :gutter="20" type="flex"
        justify="space-between"
      >
        <el-col :span="11">
          <p class="badge-title">
            ADEUDO AL DÍA DE HOY
          </p>
          <p class="subtitle">
            <b>Impuesto:</b>
            {{ $currencyFormater(debtsTotal) }}
          </p>
          <p class="subtitle">
            <b>Redondeo:</b>
            {{ $currencyFormater(debtsTotalExtra) }}
          </p>
          <p class="subtitle">
            <b>Total a pagar:</b>
            {{ $currencyFormater(debtsTotalRounded) }}
          </p>
        </el-col>
        <el-col :span="11">
          <p class="badge-title" style="height: 30px; line-height: 30px;">
            TOTAL A PAGAR
          </p>
          <p class="subtitle">
            <b>Impuesto:</b>
            {{ $currencyFormater(debtsTotalRounded) }}
          </p>
          <p class="subtitle">
            <b>Donativo OPD SERVICIOS DE SALUD DEL MUNICIPIO DE ZAPOPAN:</b>
            {{ healthService ? $currencyFormater(healthServicesTotal)
              : $currencyFormater(0) }}
          </p>
          <p class="subtitle" v-if="houseInsuranceTotal">
            <b>SEGURO CASA HABITACIONAL:</b>
            {{ houseInsurance ? $currencyFormater(houseInsuranceTotal)
              : $currencyFormater(0) }}
          </p>
          <p class="subtitle">
            <b>Total a pagar:</b>
            {{ $currencyFormater(debtsTotalFinal) }}
          </p>
        </el-col>
      </el-row>
      <p class="select">
        Seleccione opción de pago
      </p>
      <el-row
        :gutter="24"
      >
        <el-radio-group
          v-model="selectedOption"
        >
          <el-row
            justify="center"
          >
            <el-col
              :xs="24"
              :sm="12"
              :md="12"
              :lg="12"
              :xl="12"
              class="checks"
              v-if="houseInsuranceTotal"
            >
              <el-radio
                :label="0"
                @change="onChangeRadio"
              >
                <p style="color:#D6188C">
                  + SEGURO CASA HABITACIONAL
                </p>
                <p style="color: #FF7906">
                  + APOYO SERV. SALUD
                </p>
                <p class="amount">
                  {{ $currencyFormater(
                    debtsTotalRounded
                      + healthServicesTotal
                      + houseInsuranceTotal) }}
                </p>
              </el-radio>
              <el-radio
                :label="1"
                @change="onChangeRadio"
              >
                <p style="color:#D6188C">
                  + SEGURO CASA HABITACIONAL
                </p>
                <p class="amount">
                  {{ $currencyFormater(debtsTotalRounded + houseInsuranceTotal) }}
                </p>
              </el-radio>
            </el-col>
            <el-col
              :xs="24"
              :sm="12"
              :md="houseInsurance ? 12 : 24"
              :lg="houseInsurance ? 12 : 24"
              :xl="houseInsurance ? 12 : 24"
              class="checks"
            >
              <el-radio
                :label="2"
                @change="onChangeRadio"
              >
                <p style="color: #FF7906">
                  + APOYO SERV. SALUD
                </p>
                <p class="amount">
                  {{ $currencyFormater(debtsTotalRounded + healthServicesTotal) }}
                </p>
              </el-radio>
              <el-radio
                :label="3"
                @change="onChangeRadio"
              >
                <p style="color: #33BFBB">
                  SOLO IMPUESTO PREDIAL
                </p>
                <p class="amount">
                  {{ $currencyFormater(debtsTotalRounded) }}
                </p>
              </el-radio>
            </el-col>
          </el-row>
        </el-radio-group>
      </el-row>
      <el-row
        type="flex" justify="space-between"
        style="margin-top: 20px"
        class="buttons"
      >
        <div>
          <router-link to="/estado-de-cuenta">
            <el-button>
              Imprimir recibo
            </el-button>
          </router-link>
          <router-link to="/busqueda-del-predio" style="margin-left: 10px">
            <el-button>
              Consultar otra cuenta
            </el-button>
          </router-link>
        </div>
        <el-button
          @click="addToCartAndRedirect"
        >
          Pagar
        </el-button>
      </el-row>
    </el-col>
  </el-container>
</template>
<script>
import Moment from 'moment';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      selectedOption: -1,
      houseInsurance: false,
      healthService: true,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.predio.user,
      data: (state) => state.predio.data,
    }),
    /**
     * Filtra la información del Web Service y regresa
     * los adeudos de impuesto
     * @readonly
     * @returns {Array<Object>}
     */
    debtsData() {
      // Expresión regular para buscar la palabra 'impuesto' en mayúscula y minúscula
      // const regExp = new RegExp('impuesto', 'i');
      const regExp = /(impuesto|gastos|notificacion)/i;
      /**
       * Filtra los datos del web service aplicando la expresión
       * regular en el campo de 'observaciones'
       */
      const output = this.data.filter((x) => regExp.test(x.observaciones));
      // Objeto de fecha
      const currentDate = new Moment();
      // Obtenemos el año actual en valor numérico
      const currentYear = parseInt(currentDate.format('YYYY'), 10);
      // Obtenemos el mes actual en valor numérico
      const currentMonth = parseInt(currentDate.format('MM'), 10);
      // Obtenemos el día actual en valor numérico
      const currentDay = parseInt(currentDate.format('DD'), 10);

      /**
       * Busca la información de adeudos de predio que ya han vendido
       * relativo a la fecha actual y modifica cada elemento en la
       * colección de ser necesario.
       */
      const arrayFields = output.map((x) => {
        // Buscamos el año con una expresión regular en el campo 'observaciones'.
        let yearMatch = /predial ([0-9]{0,4})|predial|gastos|notificacion/i.exec(x.observaciones)[1];
        /**
         * Revisamos que la búsqueda nos haya retornado un valor para en caso de ser cierto
         * convertir el valor de texto a valor numérico.
         */
        yearMatch = typeof yearMatch === 'string' ? parseInt(yearMatch, 10) : null;

        // Buscamos el número del bimestre con una expresión regular en el campo 'observaciones'.
        // let numMatch = /(bim.|bimestre) ([0-9]{0,2})/i.exec(x.observaciones)[2];
        let numMatch = /(((bim.|bimestre) ([0-9]{0,2}))|predial|gastos|notificacion)/i.exec(x.observaciones)[2];
        /**
         * Revisamos que la búsqueda nos haya retornado un valor para en caso de ser cierto
         * convertir el valor de texto a valor numérico.
         */
        numMatch = typeof numMatch === 'string' ? parseInt(numMatch, 10) : null;

        /**
         * Verifica si el año y bimestre ya vencieron.
         * De ser cierto, coloca la bandera 'disabled' en 'true',
         * para que los datos no pueden ser deseleccionados de la tabla.
         */
        const months = (numMatch * 2) - 1;

        const disabled = (yearMatch && yearMatch < currentYear)
        || (yearMatch && yearMatch >= currentYear && currentMonth > months)
        || (yearMatch && yearMatch >= currentYear && numMatch
        && (currentMonth >= months && currentDay > 15));
        // Retorna el elemento o información de predio con las banderas preparadas.
        return {
          ...x,
          disabled,
          currentYear: yearMatch && yearMatch === currentYear,
          checked: typeof x.checked === 'boolean' ? x.checked : true,
        };
      });
      return arrayFields;
    },
    /**
     * Calcula el total de adeudo
     * @readonly
     * @returns {Number}
     */
    debtsTotal() {
      // Obtener todos los elementos que esten marcados en la tabla (checked = true).
      const items = this.debtsData.filter((x) => x.checked === true);
      const allExpiredChecked = true;
      // const allExpiredChecked = items.some((e) => !e.disabled);
      const allChecked = this.debtsData.length === items.length && allExpiredChecked;
      // Variable de suma.
      let sum = 0;
      // Recorremos todos los registros marcados
      for (let i = 0; i < items.length; i++) {
        // Obtenemos el registro
        const element = items[i];
        let adeudo = 0;
        if (element.currentYear) {
          if (allChecked) {
            adeudo = element.adeudo - element.descuentoBase - element.descuentoAplicable;
          } else if (allExpiredChecked) {
            adeudo = element.adeudo - element.descuentoBase;
            /*
              - element.descuentoAplicable
              + element.descuentoAplicableCargo + element.descuentoRecargoAplicable
              + element.descuentoMultaAplicable;
            */
          } else {
            adeudo = element.adeudo - element.descuentoBase;
          }
        } else if (allExpiredChecked) {
          adeudo = element.adeudo - element.descuentoBase - element.descuentoAplicable;
        } else {
          adeudo = element.adeudo - element.descuentoBase;
        }
        // console.log('******adeudo '+adeudo);
        sum += adeudo * 1000;
      }
      /**
       * Dividimos la suma entre 1000 para
       * obtener el resultado filal con 4 decimales
       */
      sum /= 1000;
      // Retornamos el total de la suma
      return sum;
    },
    /**
     * Retorna el total de adeudo del predio redondeado.
     * @readonly
     * @returns {Number}
     */
    debtsTotalRounded() {
      return Math.round(this.debtsTotal);
    },
    /**
     * Retorna los decimales omitidos del total redondeado.
     * @readonly
     * @returns {Number}
     */
    debtsTotalExtra() {
      return this.debtsTotalRounded - this.debtsTotal;
    },
    /**
     * Retorna los cargos de servicios de salud
     * @readonly
     * @returns {Array<Object>}
     */
    healthServices() {
      /**
       * Expresión regular para buscar la frase 'servicios de salud'
       * en mayúsculas o minúsculas
       */
      const regExp = new RegExp('SERVICIOS DE SALUD', 'i');
      // Aplicamos la expresión regular al filtro por el campo 'observaciones'
      const rows = this.data.filter((row) => regExp.test(row.observaciones));
      // Retornamos la suma de los elementos obtenidos
      console.log('OPD');
      console.log(rows);
      return rows;
    },
    /**
     * Retorna el total de servicios de salud
     * @readonly
     * @returns {Number}
     */
    healthServicesTotal() {
      // Retornamos la suma de los elementos
      /*
        return this.healthServices
        .reduce((prev, curr) => prev + (curr.importe_base || curr.adeudo), 0);
      */
      return 30;
    },
    /**
     * Retorna los cargos de SEGURO CASA HABITACIONAL
     * @readonly
     * @returns {Number}
     */
    houseInsurances() {
      /**
       * Expresión regular para buscar la frase 'SEGURO CASA HABITACIONAL'
       * en mayúsculas o minúsculas
       */
      const regExp = new RegExp('SEGURO CASA HABITACIONAL', 'i');
      // Aplicamos la expresión regular al filtro por el campo 'observaciones'
      const rows = this.data.filter((row) => regExp.test(row.observaciones));
      // Retornamos la suma de los elementos obtenidos
      return rows;
    },
    /**
     * Retorna el total del SEGURO CASA HABITACIONAL
     * @readonly
     * @returns {Number}
     */
    houseInsuranceTotal() {
      // Retornamos la suma de seguro casa habitacional
      return this.houseInsurances.reduce((prev, curr) => prev + curr.adeudo, 0);
      // return 0;
    },
    /**
     * Retorna el total final a pagar según la opción que se haya seleccionado.
     * @readonly
     * @returns {Number}
     */
    debtsTotalFinal() {
      let total = this.debtsTotalRounded;
      total += this.houseInsurance ? this.houseInsuranceTotal : 0;
      total += this.healthService ? this.healthServicesTotal : 0;
      return total;
    },
  },
  methods: {
    /**
     * Captura el cambio en la selección de
     * las opciones a pagar.
     */
    onChangeRadio() {
      switch (this.selectedOption) {
        case 0:
          this.houseInsurance = true;
          this.healthService = true;
          break;
        case 1:
          this.houseInsurance = true;
          this.healthService = false;
          break;
        case 2:
          this.houseInsurance = false;
          this.healthService = true;
          break;
        case 3:
          this.houseInsurance = false;
          this.healthService = false;
          break;
        default:
          break;
      }
    },
    /**
     * Añade al "carrito" el plan de pago seleccionado
     * y redirecciona al usuario a la pantalla de pago.
     */
    addToCartAndRedirect() {
      const {
        ubicacion,
        curt,
        cuentadepredial,
        clave_catastral: claveCatastral,
      } = this.user;
      const description = `Predio: ${ubicacion}`;
      let total = this.debtsTotalRounded;
      console.log('----data ');
      console.log(this.data);
      console.log('----predio ');
      console.log(this.user);
      console.log(` selected option ${this.selectedOption}`);
      switch (this.selectedOption) {
        case 0:
          total = this.debtsTotalRounded + this.healthServicesTotal + this.houseInsuranceTotal;
          this.user.tiene_opd = 1;
          this.user.tiene_seguro = 1;
          break;
        case 1:
          total = this.debtsTotalRounded + this.houseInsuranceTotal;
          console.log(`QUITANDO OPD ${this.user.OPD} ${this.user.cargos.replace(`${this.user.OPD};`, '')}`);
          this.user.cargos.replace(`${this.user.OPD};`, '');
          this.user.cargos = this.user.cargos.replace(`${this.user.OPD};`, '');
          this.user.cargos = this.user.cargos.replace(this.user.OPD, '');
          this.user.tiene_opd = 0;
          this.user.tiene_seguro = 1;
          break;
        case 2:
          console.log(`QUITANDO SEGUROO ${this.user.SEGURO} ${this.user.cargos.replace(`${this.user.SEGURO};`, '')}`);
          total = this.debtsTotalRounded + this.healthServicesTotal;
          this.user.cargos = this.user.cargos.replace(`${this.user.SEGURO};`, '');
          this.user.cargos = this.user.cargos.replace(this.user.SEGURO, '');
          this.user.tiene_opd = 1;
          this.user.tiene_seguro = 0;
          break;
        default:
          this.user.cargos = this.user.cargos.replace(`${this.user.OPD};`, '');
          this.user.cargos = this.user.cargos.replace(`${this.user.SEGURO};`, '');
          this.user.cargos = this.user.cargos.replace(this.user.SEGURO, '');
          this.user.cargos = this.user.cargos.replace(this.user.OPD, '');
          this.user.tiene_opd = 0;
          this.user.tiene_seguro = 0;
          break;
      }
      console.log('----predio DESPUES SWITCH');
      console.log(this.user.cargos);
      console.log('----user DESPUES SWITCH');
      console.log(this.user);

      if (total >= 0) {
        const cargosSalud = this.healthService
          ? this.healthServices.reduce((accum, curr) => accum.concat(curr.cargos), []) : [];
        const cargosSeguroHabitacinal = this.houseInsurance
          ? this.houseInsurances.reduce((accum, curr) => accum.concat(curr.cargos), []) : [];

        this.$store.dispatch('cart/SET_DATA', {
          cuentadepredial: cuentadepredial !== '0' ? cuentadepredial : null,
          curt,
          description,
          total,
          extra: this.debtsTotalExtra,
          claveCatastral: claveCatastral !== '0' ? claveCatastral : null,
          cargos: this.debtsData.filter((x) => x.checked === true)
            .reduce((accum, curr) => accum.concat(curr.cargos), [])
            .concat(cargosSalud).concat(cargosSeguroHabitacinal),

        });
        setTimeout(() => {
          let path = '/pagar';
          if (this.$isWebView()) {
            path = '/movil/referencia-de-pago';
          }
          this.$router.push({ path, query: this.$route.query });
        });
      }
    },
  },
  /**
   * Limpia el 'carrito' en el estado global de la aplicación
   * al entrar a la página.
   */
  created() {
    if (this.houseInsuranceTotal === 0) {
      this.houseInsurance = false;
      this.selectedOption = 2;
    } else {
      this.selectedOption = 0;
      this.houseInsurance = true;
    }
    this.$store.dispatch('cart/CLEAR_DATA');
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  .title {
    color: #330066;
    font-size: 14pt;
    font-weight: bold;
  }
  .badge-title {
    color: White;
    background-color: #B9A5CB;
    font-family: Segoe UI;
    font-weight: bold;
    font-size: 16px;
    border-radius: 5px;
    text-align: center;
    padding: 3px;
    margin: 5px 0;

    width: 150px;
    word-wrap: break-word;
  }
  .subtitle {
    font-size: 16px;
    margin: 4px 0;
  }
  .logo {
    height: 120px;
    align-self: flex-start;
  }
  .select {
    color: #330066;
    font-size: 14pt;
    font-weight: bold;
  }
  .el-radio-group {
    width: 100%;
    .el-radio {
      white-space: normal;
      display: flex;
      align-items: center;
      .el-radio__label p {
        width: 120px;
        word-wrap: break-word;
        margin: 0px;
        font-size: 9pt;
        font-weight: bold;
      }
      p.amount {
        color: #000000;
        font-size: 16px;
        font-weight: bold;
        font-family: Arial;
      }
      margin: 0 10px;
      padding: 5px;
      width: 40%;
    }
  }
  .el-button {
    background-color: #956FA8;
    color: #FFFFFF;
    font-weight: bold;
  }
  .checks {
    border: Solid;
    border-color: #9F9F9F;
    border-width: 1px;
    // &:nth-child(2) {
    //   border-left-width: 0px;
    // }
    // &:nth-child(1) {
    //   border-right-width: 0px;
    // }
  }
}

@media only screen and (max-width: 767px) {
  .el-radio {
    width: 40% !important;
  }
  // .checks {
  //   &:nth-child(2) {
  //     border-left-width: 1px !important;
  //     border-top-width: 0px !important;
  //   }
  //   &:nth-child(1) {
  //     border-right-width: 1px !important;
  //     border-bottom-width: 0px !important;
  //   }
  // }
}

@media only screen and (min-width: 530px) {
  .checks {
    display: flex !important;
    flex-direction: row;
  }
  .el-radio {
    width: 100% !important;
  }
}
@media only screen and (max-width: 530px) {
  p {
    font-size: 12px !important;
  }
  .badge-title {
    width: 110px !important;
  }
  .logo {
    height: 80px !important;
  }
  .el-radio {
    width: 100% !important;
    .el-radio__label p {
        width: 100% !important;
        font-size: 12px !important;
      }
  }
  .buttons {
    display: flex;
    flex-direction: column;
    a {
      margin: 0 !important;
      }
    .el-button {
      margin: 5px 0 !important;
      width: 100% !important;
    }
  }
}
</style>

<style lang="scss">
.el-radio {
  .el-radio__label {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
}
.el-radio__input.is-checked .el-radio__inner {
  border-color: rgb(42, 149, 236);
  background: rgb(42, 149, 236);
}
.el-radio__label {
  height: 64px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
}
@media only screen and (max-width: 530px) {
.el-radio__label {
    height: 40px !important;
  }
}
</style>
